import LazyLoad from "react-lazyload";
const ServiceItem = ({ icon, title, description }) => {
  return (
    <div className="flex items-start gap-4 py-4 md:py-6  last:border-none">
      <div className="min-w-[40px] min-h-[40px] flex items-center justify-center rounded-lg bg-white shadow">
        {icon}
      </div>
      <div className="flex-1">
        <h4 className="font-semibold text-base md:text-lg text-gray-900 mb-1">
          {title}
        </h4>
        <p className="text-gray-700 text-sm md:text-base leading-relaxed">
          {description}
        </p>
      </div>
    </div>
  );
};

export default ServiceItem;
